interface PersonNameParts {
  surname?: string | null;
  name?: string | null;
  middlename?: string | null;
}

export const buildFullName = (person?: PersonNameParts | null): string =>
  [person?.surname, person?.name, person?.middlename].filter(Boolean).join(' ');
